import React from 'react'
import { withFirebase } from '../Fb'

// reactstrap components
import { Row, Col, Button, Card, CardText, CardBody } from 'reactstrap'

import MaintenanceTicketTargets from './MaintenanceTicketTargets.jsx'
import MaintenanceTicketClasses from './MaintenanceTicketClasses.jsx'

// core components

const service = 'maintenancetickets'

class BuildingMaintenanceTicketsSettingsContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      saving: false,
      enabled: false,
    }
  }

  componentDidMount() {
    if (
      this.props.modules &&
      this.props.modules[service] &&
      this.props.modules[service].enabled
    ) {
      this.setState({ enabled: true })
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.modules && this.props.modules[service]) {
      if (
        this.props.modules[service].enabled &&
        !prevProps.modules[service]?.enabled
      ) {
        this.setState({ enabled: true })
      }
      if (
        !this.props.modules[service].enabled &&
        prevProps.modules[service]?.enabled
      ) {
        this.setState({ enabled: false })
      }
    } else {
      if (this.state.enabled) {
        this.setState({ enabled: false })
      }
    }
  }

  disableModule = async () => {
    this.setState({ saving: true })
    await this.props.firebase.disableModule(service)
  }

  render() {
    return (
      <>
        <div className='content'>
        <Row>
            <Col md='12'>
            {this.state.enabled ? (
                <Button color='danger' onClick={this.disableModule}>
                  Peruuta palvelu
                </Button>
              ) : (
                  <Card>
                    <CardBody>
                    <CardText>
                    Palvelu ei ole aktivoitu. Voit aktivoida sen Kiinteistöhuolto -> Tiketit -sivulta.
                      </CardText>
                    </CardBody>
                </Card>
              )}
              
              </Col>
            </Row>
          <Row >
            <Col md='12'>
              <MaintenanceTicketTargets />
            </Col>
          </Row>
          <Row style={{ marginTop: 20 }}>
            <Col md='12'>
              <MaintenanceTicketClasses />
            </Col>
          </Row>
          
          
        </div>
      </>
    )
  }
}

export default withFirebase(BuildingMaintenanceTicketsSettingsContainer)
